export default __webpack_public_path__ + "static/media/specialist@2x.dc1d0980.png";